import type { StylableProps } from "@mdotm/shadcn/legacy/components";
import { overrideClassName } from "@mdotm/shadcn/legacy/react-extensions";
import { themeCSSVars } from "@mdotm/shadcn/legacy/themes";

export type DividerProps = StylableProps & {
	color?: string;
	direction?: "horizontal" | "vertical"
};

export function Divider(props: DividerProps): React.JSX.Element {
	const { direction = "horizontal" } = props;
	return (
		<div
			className={overrideClassName({ "border-b my-1": direction === "horizontal", "border-l": direction === "vertical"}, props.className)}
			style={{ borderColor: props.color ?? themeCSSVars.palette_N100, ...props.style }}
		/>
	);
}
